// extracted by mini-css-extract-plugin
export default {"navlinkContainer":"navlink_navlinkContainer__bDquV","navlinkTextBlue":"navlink_navlinkTextBlue__gvjY+","navlinkText":"navlink_navlinkText__o9H8Z"};